<template>
  <div>
    <el-drawer @reload="$reloadHandle" title="技术支持岗审核" size="30%" :before-close="handleClose" :visible.sync="drawer"
      append-to-body="ture" direction="rtl" :modal-append-to-body="true" custom-class="demo-drawer" ref="drawer">
      <i class="el-icon-info" />
      单据号：<span v-if="exchangeNo" style="font-weight: 600;color: #2196f3;margin-right: 5px;">{{
        exchangeNo }}</span>
      <div class="demo-drawer__content">
        <div id="containt">
          <div class="tab-box">
            <el-form :label-position="right" label-width="80px" ref="editForm" :model="formData">
              <div style="display: flex;justify-content: space-between;flex-wrap: nowrap;align-items: center;">
                <div class="title first"><b>附件列表</b></div>
                <el-upload style="display:flex; float: right" class="upload-demo" ref="upload"
                           :action="'/admin/sys-file/upload'"  :show-file-list="false" accept=".jpeg,.jpg,.png,.gif,.mp4,.avi,.rmvb,.rm,.wmv,.3gp,.mp3"
                           :on-success="(res, file, fileList) => { handleFileSuccess(res, file, fileList) }" :headers="headers"
                           :auto-upload="true">
                  <el-button type="primary" class="button-sty btn_zdy">
                    <i class="el-icon-plus"></i>
                    附件
                  </el-button>
                </el-upload>
              </div>
              <vxe-table style="margin-top: 0px;" :stripe="true"
                         :header-cell-style="{ height: '30px', background: '#EFF6FC', padding: '0', borderTop: '1px solid #eaeaea', fontSize: '12px', color: '#808080', width: '95%' }"
                         :row-config="{ height: 30, isHover: true, padding: 0, }" :row-style="{ fontSize: '12px', }"
                         show-overflow height="210" :column-config="{ resizable: true }" @checkbox-change="selectChangeEvent"
                         @checkbox-all="selectChangeEvent" :data="formData.fileList">
                <vxe-column field="fileName" title="附件名称" width="250">
                  <template #default="{ row }">
                    <span @click="openVideo(row.fileUrl)">{{ row.fileName }}</span>
                  </template>
                </vxe-column>

                <vxe-column title="操作" width="150">
                  <template #default="{ row }">
                    <!-- 下载 -->
                    <div>
                    </div>
                    <div>
                      <el-tooltip :enterable="false" effect="dark" content="下载" placement="top"
                                  popper-class="tooltip-skin">
                        <i @click="handleDownload(row.fileName, row.fileUrl)" class="el-icon-download"
                           style="font-size: 18px; color: #00c4b3;    margin-left: 10px;"></i>
                      </el-tooltip>

                      <el-tooltip :enterable="false" effect="dark" content="预览文件" placement="top"
                                  popper-class="tooltip-skin">
                        <i @click="openVideo(row.fileUrl)" class="el-icon-view"
                           style="font-size: 18px; color: #00c4b3;    margin-left: 10px;"></i>
                      </el-tooltip>
                      <el-tooltip :enterable="false" effect="dark" content="删除" placement="top"
                                  popper-class="tooltip-skin">
                        <i @click="deleteFile(row)" class="el-icon-delete" style="font-size: 18px; color: #00c4b3;margin-left: 10px;"></i>
                      </el-tooltip>
                    </div>
                  </template>
                </vxe-column>
              </vxe-table>
            </el-form>
          </div>
        </div>
      </div>

      <div class="demo-drawer__content">
        <div class="demo-drawer__footer" style="position: absolute;
    bottom: 5px;
    right: 5px;">
          <el-button @click="cancelForm">取 消</el-button>
          <el-button type="primary"  @click="siteAppeal">
            确 定
          </el-button>
        </div>
      </div>
    </el-drawer>
    <Preview v-if="showPreview" @closeD="closePreview" :visiable.sync="showPreview" :imgVisbleURL="imgVisbleURL" />
  </div>
</template>
<script>
import api from "@/api/projectApi";
import { dictType, loadDictData } from "@/config/dictType";
import Preview from "@/views/dialogCommon/PreviewDialog.vue";
import store from "@/store";

export default {
  components: {Preview},
  inject: ['reload'],
  name: 'edit',
  props: ['multi', 'confirmNo', 'dataId', 'wf'],
  created() {
    console.log(this.wf)
    this.formData.id = this.dataId
    if (this.wf) {
      this.exchangeNo = this.wf.orderNo
      this.formData.processId = this.wf.processId
      this.formData.taskId = this.wf.taskId
      this.formData.messageContent = this.wf.messageContent
      this.formData.id = this.wf.orderId
    }
  },
  data() {
    return {
      selectedData:[],
      exchangeNo: '',
      imgVisbleURL: '',
      showPreview: false,

      formData: {
        id: null,
        processId: null,
        taskId: null,
        messageContent:null,
        fileList:[],
      },
      showOrderPop: false,

      drawer: true,
    }
  },
  computed: {
    headers: function () {
      const tenantId = store.getters.userInfo.tenantId
      return {
        'Authorization': "Bearer " + store.getters.access_token,
        'TENANT-ID': tenantId
      }
    },
  },
  methods: {
    deleteFile(row) {
      this.$baseConfirm('您确定要删除吗？').then(() => {
        this.formData.fileList = this.formData.fileList.filter(item => item.fileUrl !== row.fileUrl)
      })
    },
    closePreview() {
      this.showPreview = false
    },
    selectChangeEvent(data) {
      console.log('选中数据', data)
      this.selectedData = data.records
    },

    openVideo(value) {
      this.imgVisbleURL = value
      this.showPreview = true
    },
    handleFileSuccess(res, file, fileList) {

      let url = res.data.url
      let fileName = file.name
      console.log(url, "url")
      console.log(fileName, "name")
      this.formData.fileList.push({
        fileName: fileName,
        fileUrl: url
      })
      this.$message({
        message: '附件上传成功',
        type: 'success'
      });
      this.$mask.close()
    },

    handleDownload(Vname,Vurl) {
      console.log(Vname,Vurl, "文件下载");
      // let url=file.type
      let url = Vurl
      let name = Vname

      const x = new XMLHttpRequest()
      x.open('GET', url, true)
      x.responseType = 'blob'
      x.onload = function () {
        const url = window.URL.createObjectURL(x.response)
        const a = document.createElement('a')
        a.href = url
        a.download = name
        a.click()
      }
      x.send()


      // window.open(url,'_blank');
    },
    // 考核的确认
    siteAppeal() {
      this.$baseConfirm('您确定要保存吗？').then(() => {
        this.$mask.open()
        this.$http({
          url: "/basic/wkExchangeBill/technologyCheck",
          method: 'post',
          data: this.formData
        }).then(res => {
          this.$mask.close()
          this.$message.success('确认成功')
          this.$emit('closeD')
          this.$emit('flushed')
        }).catch(() => {
          this.$mask.close()
        })
      });
    },
    // 加载数据字典中物流公司，运输方式
    loadDictData() {
      loadDictData("处理方案名称").then(res => {
        this.dealWayList = []
        res.data.data.forEach(item => {
          this.dealWayList.push({
            label: item.label,
            value: item.id
          })
        })
      })
    },
    confirm() {
      this.drawer = false;
      this.handleClose()
    },
    cancelForm() {
      this.loading = false;
      this.drawer = false;
      clearTimeout(this.timer);
    },
    handleClose() {

      this.drawer = false;
      this.$emit('closeD', false)
    }
  },
  mounted() {
    this.loadWarehouse()
  },
}
</script>
<style lang="scss" scoped>
::v-deep .el-drawer .el-drawer__body {
  padding: 0 16px;
  background-color: #fff;
  position: relative;
}

::v-deep .el-drawer .el-drawer__header {
  background-color: #fff;
}

::v-deep .el-drawer__container {
  position: relative;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  height: 100%;
  width: 100%;
  background: aliceblue;
  background-color: rgb(38 38 38 / 70%);
}

#containt .table-detail {
  border-collapse: collapse;
  font-size: 12px;
  border: 1px solid #ededed;
}

.btn {
  text-align: center;
}
</style>
